import { Button } from '@rhg/libs/material';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { navItemsMessages } from '../nav-items/messages';
import { QrCodeDialog } from '../qr-code-dialog';

export const QrCodeBanner = () => {
    const { formatMessage } = useIntl();
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    return (
        <>
            <Button
                size="medium"
                trackButton="UseMobileApp"
                variant="outlined"
                onClick={() => setIsDialogOpen(true)}
            >
                {formatMessage(navItemsMessages.useMobileAppCta)}
            </Button>

            <QrCodeDialog
                isOpen={isDialogOpen}
                onClose={() => setIsDialogOpen(false)}
                trackDialog="LookingForCalmApp"
                trackCloseButton="UseMobileAppBannerClose"
            />
        </>
    );
};
